import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-test"]
const _hoisted_2 = { class: "calendar__menu__date__item-container flex items-stretch justify-stretch flex-auto" }
const _hoisted_3 = { class: "calendar__menu__date__item flex items-center justify-center" }
const _hoisted_4 = { class: "calendar__menu__date-label" }

import { CalendarModeOptions } from 'frontcore/presentation/calendar/domain/types'
import { computed } from 'vue'

interface Props {
  date: Date,
  isDisabled: boolean,
  isCurrentDate: boolean,
  isEndDate: boolean,
  isInRange: boolean,
  isSelected: boolean,
  isStartDate: boolean,
  isLastDayOfWeek: boolean,
  isHoveredWeek: boolean,
  mode: number,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarDayNumber',
  props: {
    date: {},
    isDisabled: { type: Boolean },
    isCurrentDate: { type: Boolean },
    isEndDate: { type: Boolean },
    isInRange: { type: Boolean },
    isSelected: { type: Boolean },
    isStartDate: { type: Boolean },
    isLastDayOfWeek: { type: Boolean },
    isHoveredWeek: { type: Boolean },
    mode: {}
  },
  emits: ["mouseenter", "mouseleave", "click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const dataTest = computed((): string => `calendar-menu-date-${props.date.getMonth()}-${props.date.getDate()}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    "data-test": dataTest.value,
    class: _normalizeClass([{
      'calendar__menu__date--disabled': _ctx.isDisabled,
      'calendar__menu__date--end': _ctx.isEndDate,
      'calendar__menu__date__week--hovered': _ctx.isHoveredWeek,
      'calendar__menu__date__week--end': _ctx.isLastDayOfWeek,
      [_ctx.mode === _unref(CalendarModeOptions).SELECT_WEEK ? 'calendar__menu__date__week--in-range' :'calendar__menu__date--in-range']: _ctx.isInRange,
      [_ctx.mode === _unref(CalendarModeOptions).SELECT_WEEK ? 'calendar__menu__date__week--selected' : 'calendar__menu__date--selected']: _ctx.isSelected,
      'calendar__menu__date--start': _ctx.isStartDate,
      'calendar__menu__date--today': _ctx.isCurrentDate,
    }, "calendar__menu__date flex-auto buttons--button-01"]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', $event))),
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (emit('mouseenter'))),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (emit('mouseleave')))
  }, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "calendar__menu__date__range-indicator" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.date.getDate()), 1)
      ])
    ])
  ], 42, _hoisted_1))
}
}

})